module.exports = __webpack_public_path__ + "static/media/10.02beb71e.mp4";